import React, { useEffect, useState } from 'react'
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, navigate, useNavigate } from 'react-router-dom';
import { Card, Col, Container, Dropdown, Nav, Navbar, Row } from 'react-bootstrap';
import logo1 from '../Assets/logonew.png'
import "../Admin/AdminMaster/AdminBilling.css";
import './Master.css'
import { Button, Form, Modal, Table } from 'react-bootstrap'
import axios from 'axios'
import { toast } from 'react-toastify'
import { EmployeeAdd, EmployeeDelete, EmployeeFindAll, EmployeeUpdate } from '../Admin/API/Api'
import AdminNavBar from './AdminNavBar';
import NavLogo from './NavLogo';
import { MDBDataTable } from 'mdbreact';


const EmployeeMaster1 = () => {

    const navigate = useNavigate();
    const selectedLanguage = sessionStorage.getItem('selectedLanguage');
    const userdata = JSON.parse(sessionStorage.getItem('userdata'));
    const branchId = userdata.branch_id;
    const Name = userdata ? userdata.branch_name : '';

  const [show, setShow] = useState(false);
  const [employeeName, setEmployeeName] = useState();
  const [phone, setPhone] = useState();
  const [address, setAddress] = useState();

  const [data, setData] = useState([]);
  const [isEditing, setisEditing] = useState(false);
  const [employeeId, setEmployeeId] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showEdit, setShowEdit] = useState(false);

  // =========== delete modal =========
 const [show1, setShow1] = useState(false);
 const handleClose1 = () => setShow1(false);

 const [itemToDelete, setItemToDelete] = useState(null);

 const handleShow1 = (item) => {
   setItemToDelete(item);
   setShow1(true);
 };  

//  =========== Edit ======
  const handleEditClose = () => {
    setShowEdit(false);
    setEmployeeId('');
    setEmployeeName('');
    setPhone('');
    setAddress('');
  };

  const handleEditShow = (item) => {
    setEmployeeId(item.employee_id);
    setEmployeeName(item.name);
    setPhone(item.mobileno);
    setAddress(item.address);
    setShowEdit(true);
  };

  const updateCustomer = () => {

    if (!employeeName || !phone || !address) {
      alert("All fields are required");
      return;
   }
   
    const formData = {
      name : employeeName ,
      mobileno : phone,
      address : address,
    };
    axios
      .put(`${EmployeeUpdate}${employeeId}`, formData)
      .then((res) => {
        if (res.data === "UPDATE") {
          
          toast.success("Data Updated Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          Getdata();
          handleEditClose();
        }
      })
      .catch((err) => {
        // Add debugging information to identify the issue
        console.error("Error while updating Employee:", err);
        if (err.response) {
          console.error("Response data:", err.response.data);
        }
  
        toast.error("Failed to update data, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };


const savedata = (e) => {
    e.preventDefault();
  
    if (!employeeName || !phone || !address) {
      alert("All fields are required");
      return;
   }
  
    const obj ={
      name : employeeName,
      mobileno : phone,
      address : address,
      branch_id : branchId
    }
    console.log("FormData",obj)
  
    axios
      .post(EmployeeAdd, obj)
      .then((res) => {
        
        if (res.data === "SAVED") {
          console.log("res.data",res.data)
          toast.success("Data Saved Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          // Reset form fields and reload the data
          Getdata();
          setEmployeeName('');
          setEmployeeId('');
          setPhone('');
          setAddress('');
          setShow(false);
          // window.location.reload(); // Note: Reloading the entire page may not be the best practice, consider updating the data from the API.
        }
      })
      .catch((err) => {
        toast.error("Failed to upload, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.error(err);
      });
  };

     //Getdata Logic
     const Getdata = (e) => {
      console.log("api...",`${EmployeeFindAll}/${branchId}`);
      axios  
        .get(`${EmployeeFindAll}/${branchId}`)
        .then((res) => {
          console.log("findallllllllll",res.data)
          if (res.data !== null) {
            setData(res.data);
          }
          setisEditing(false);
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
  let isEmployeeFetched = false
  useEffect(() => {
    if (isEmployeeFetched) return
      Getdata();
    isEmployeeFetched = true
  }, [])
  
    //delete data
    const onDelete = (item) => {
      console.log("Deleting item:", item);
      axios  
        .delete(`${EmployeeDelete}${item.employee_id}`)
        .then((res) => {
          console.log("Delete response:", res.data);
          if (res.data === "DELETE") {
            // alert("File Deleted Succesfully");
            toast.success("Data Deleted Succesfuly!", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
          handleClose1(false)
          Getdata();
        })
        .catch((err) => {
          // alert("Failed to upload, try again");
          console.log("Error deleting item:", err);
          toast.error("Failed to upload, try again", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          console.log(err);
        });
    };
  
    const columns = [

      { label: (selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'), field: 'srNo', sort: 'asc' },
      { label: (selectedLanguage === 'Marathi' ? 'कर्मचारी नाव' : 'Employee Name'), field: 'employeeName', sort: 'asc' },
      { label: (selectedLanguage === 'Marathi' ? 'मोबाईल क्र' : 'Mobile No.'), field: 'mobileNo', sort: 'asc' },
      { label: (selectedLanguage === 'Marathi' ? 'पत्ता' : 'Address'), field: 'address', sort: 'asc' },
      { label: (selectedLanguage === 'Marathi' ? 'सुधारणे' : 'Edit'), field: 'edit', sort: 'asc' },
      { label: (selectedLanguage === 'Marathi' ? 'हटवा' : 'Delete'), field: 'delete', sort: 'asc' }
    ];
  
    const rows = data.map((item,index) => ({
      srNo: index + 1,
      employeeName: item.name,
      mobileNo: item.mobileno,
      address: item.address,
      edit: (
        <button className='m-1' style={{ color: "rgb(255, 93, 0)", border: "0px", backgroundColor: "transparent" }}
          onClick={() => handleEditShow(item)}
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </button>
      ),
      delete: (
        <button className='m-1' style={{ color: "red", border: "0px", backgroundColor: "transparent" }}
          onClick={() => handleShow1(item)}
        >
          <i className="fa-solid fa-trash"></i>
        </button>
      )
    }));
  

  return (
    <div>
    <AdminNavBar />
       <section className="home-section">

       <NavLogo />

    <Row className="m-0 p-0 pt-5 px-md-4 px-2">
        <Col className=' rounded text-center pt-2'
          style={{
            display: "flex",
            justifyContent: "start",
            backgroundColor:"white",
            border:"0px",
            alignItems: "center",
            alignContent:"center",
            color: " rgb(47, 79, 79)",
          }}
        >
          <h5>{selectedLanguage === 'Marathi' ? 'कर्मचारी मास्टर' : 'EMPLOYEE MASTER'}
          </h5>
        </Col>
      </Row>

{/* ========================== Customer Master =========================== */}
  
<Row className='m-0 p-0  px-md-3  py-1 mb-5  w-100' style={{display:"flex"}}>
 
 <Row className="m-0 p-0 pt-3 px-2 ">
      <Col className=' rounded text-center py-2'
        style={{
          display: "flex",
          justifyContent: "start",
          backgroundColor:"white",
          border:"0px",
          alignItems: "center",
          alignContent:"center",
          color: " rgb(47, 79, 79)",
        }}
      ><button className='p-1 px-3' onClick={handleShow}  style={{backgroundColor:"rgb(214, 234, 248)",color:"rgb(47, 79, 79)"}}><b > + ADD </b></button>
      </Col>
    </Row>

    {/* <Row className="m-0 p-0 pt-3 px-2  rounded">
    <Col className="m-0 p-0  px-3 rounded" style={{background:"white"}} >
 <div style={{ overflowY: 'auto'}}>
<div style={{ overflowX: 'auto' }}>
   <Table striped bordered hover size="sm" className='rounded mb-3 mt-3' style={{textAlign:"center",border:"1px solid rgb(198, 204, 209)"}}>
         <thead >
             <tr > 
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Sr.No</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Employee Name</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Mobile No</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Address</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Edit</th>
                 <th style={{alignItems:"center", backgroundColor:"darkslategray",fontSize:"13px",fontFamily:"sans-serif"}} className='text-center text-light'>Delete</th>
             </tr>
         </thead>
         <tbody>
           {data.map((item,index)=>{
             return(               
             <tr className='border' style={{fontSize:"14px"}}>
                 <td style={{ textAlign:"center"}}>{index+1}</td>
                 <td style={{ textAlign:"center"}}>{item.name}</td>
                 <td style={{ textAlign:"center"}}>{item.mobileno}</td>
                 <td style={{ textAlign:"center"}}>{item.address}</td>

                 <td style={{textAlign:"center"}}>
                <button className=' m-1' style={{color:"rgb(255, 93, 0)",border:"0px", backgroundColor:"transparent"}}
                  onClick={() => handleEditShow(item)}
                ><i class="fa-solid fa-pen-to-square"></i></button></td>

                <td style={{textAlign:"center"}}>
                <button className=' m-1' style={{color:"red",border:"0px", backgroundColor:"transparent"}}
                
                onClick={() => handleShow1(item)}
                 ><i className="fa-solid fa-trash"></i></button></td>
             </tr>
              )
             })} 
         </tbody>
     </Table>
     </div>
     </div>
     </Col>
   </Row> */}

   <Row className="m-0 p-0 pt-3 px-2 rounded">
      <Col className="m-0 p-0 px-3 py-3 rounded" style={{ background: "white" }}>
        <MDBDataTable
          striped
          bordered
          className='custom-datatable'
          hover
          data={{ columns, rows }}
        />
      </Col>
    </Row>

 {/* ========================== Modal ============= */}
 <Modal className='shadow rounded' show={show} onHide={handleClose}>
    <Modal.Header className='m-0 p-0 ps-3 text-center' style={{ backgroundColor: "rgb(47, 79, 79)", color: "white" }}>
      <Modal.Title >
  <p style={{fontSize:"18px"}} className='text-center mt-2'>{selectedLanguage === 'Marathi' ? 'कर्मचारी मास्टर' : 'EMPLOYEE MASTER'}</p>
  </Modal.Title>
</Modal.Header>

<Modal.Body>
<Form encType="multipart/form-data">
<Row className='m-0'>
   <Col sm={12} md={12} className='mt-3'>
   <Form.Label><h6 >{selectedLanguage === 'Marathi' ? 'कर्मचारी नाव' : 'Employee Name'}:</h6></Form.Label>
       <Form.Control
         aria-label="Default select example"
         onChange={(e)=>setEmployeeName(e.target.value)}
         value={employeeName}
         maxLength={40}
         required
       >
       </Form.Control>
     </Col>

     <Col sm={12} md={12} className='mt-3'>
      <Form.Label><h6 >{selectedLanguage === 'Marathi' ? 'मोबाईल क्र' : 'Mobile No'} :</h6></Form.Label>
       <Form.Control
          maxLength="10"
          inputMode="numeric"  
          title='Please enter 10 digit num.'
          type="tel"
          id="mobileNumber"
          value={phone}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/\D/g, "");
            setPhone(numericValue);
          }}
          required
       >
       </Form.Control>
     </Col>
     
     <Col sm={12} md={12} className='mt-3 mb-3'>
      <Form.Label><h6 >{selectedLanguage === 'Marathi' ? 'पत्ता' : 'Address'}:</h6></Form.Label>
       <Form.Control
         aria-label="Default select example"
         onChange={(e)=>setAddress(e.target.value)}
         value={address}
         maxLength={200}
         required
       >
       </Form.Control>
     </Col>


   </Row>
  </Form>
</Modal.Body>

    <Modal.Footer className='m-0 p-0' style={{backgroundColor:"rgb(47, 79, 79)"}}>
      <Button style={{color:"black",backgroundColor:"white",border:"0px",borderRadius:"15px"}} onClick={handleClose}>
        Cancel
      </Button>

  {
    isEditing===false ? 
      <Button style={{border:"0px",backgroundColor:"rgb(135, 178, 178)" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-dark' type='submit' onClick={savedata}>
        {selectedLanguage === 'Marathi' ? 'जतन करा' : 'Save'}
      </Button>
      :
      <Button style={{border:"0px",backgroundColor:"rgb(135, 178, 178)" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-dark' type='submit' onClick={handleClose}>
      {selectedLanguage === 'Marathi' ? 'अपडेट करा' : 'Update'} 
      </Button>
      }
</Modal.Footer>
</Modal>

{/* =================== Edit Modal ======================== */}
 
<Modal show={showEdit} onHide={handleEditClose}>
      <Modal.Header className='m-0 p-0 ps-3 text-center' style={{backgroundColor:"rgb(47, 79, 79)",color:"white"}} >
      <Modal.Title >
      <p style={{fontSize:"18px"}} className='text-center mt-2'>{selectedLanguage === 'Marathi' ? 'कर्मचारी मास्टर' : 'EMPLOYEE MASTER'}</p>
      </Modal.Title>
    </Modal.Header>

    <Modal.Body>
<Form encType="multipart/form-data">
<Row className='m-0'>
   <Col sm={12} md={12} className='mt-3'>
   <Form.Label><h6 >{selectedLanguage === 'Marathi' ? 'कर्मचारी नाव' : 'Employee Name'}:</h6></Form.Label>
       <Form.Control
         aria-label="Default select example"
         onChange={(e)=>setEmployeeName(e.target.value)}
         value={employeeName}
         maxLength={40}
         required
       >
       </Form.Control>
     </Col>

     <Col sm={12} md={12} className='mt-3'>
      <Form.Label><h6 >{selectedLanguage === 'Marathi' ? 'मोबाईल क्र' : 'Mobile No'} :</h6></Form.Label>
       <Form.Control
          maxLength="10"
          inputMode="numeric"  
          title='Please enter 10 digit num.'
          type="tel"
          id="mobileNumber"
          value={phone}
          onChange={(e) => {
            const numericValue = e.target.value.replace(/\D/g, "");
            setPhone(numericValue);
          }}
          required
       >
       </Form.Control>
     </Col>
     
     <Col sm={12} md={12} className='mt-3 mb-3'>
      <Form.Label><h6 >{selectedLanguage === 'Marathi' ? 'पत्ता' : 'Address'}:</h6></Form.Label>
       <Form.Control
         aria-label="Default select example"
         onChange={(e)=>setAddress(e.target.value)}
         value={address}
         maxLength={200}
         required
       >
       </Form.Control>
     </Col>

   </Row>
  </Form>
</Modal.Body>

    <Modal.Footer className='m-0 p-0' style={{backgroundColor:"rgb(47, 79, 79)"}}>
      <Button style={{color:"black",backgroundColor:"white",border:"0px",borderRadius:"15px"}} onClick={handleEditClose}>
         {selectedLanguage === 'Marathi' ? 'रद्द करा' : 'Cancel'} 
      </Button>

          <Button style={{border:"0px",backgroundColor:"rgb(135, 178, 178)" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-dark' onClick={() => updateCustomer(employeeId,employeeName,phone,address)}>
          {selectedLanguage === 'Marathi' ? 'अपडेट करा' : 'Update'} 
          </Button>
        </Modal.Footer>
      </Modal>

            {/* ============= Delete Modal ========= */}

            <Modal show={show1} onHide={handleClose1}>
        <Modal.Header style={{backgroundColor:"rgb(47, 79, 79)",color:"white"}} >
          <Modal.Title><i className="fa-solid fa-trash" style={{ color: "rgb(254, 105, 129)" }}></i> {selectedLanguage === 'Marathi' ? 'पुष्टीकरण हटवा' : 'Delete Confirmation'}</Modal.Title>
        </Modal.Header>
        <Modal.Body >{selectedLanguage === 'Marathi' ? 'तुमची खात्री आहे की तुम्ही हा आयटम हटवू इच्छिता?' : 'Are you sure you want to delete this item?'}</Modal.Body>
          <p className='text-end'>
          <Button className='mx-2' style={{color:"black",backgroundColor:"white",border:"2px solid darkslategray",borderRadius:"15px"}}  onClick={handleClose1}>
             {selectedLanguage === 'Marathi' ? 'रद्द करा' : 'Cancel'} 
          </Button>
          <Button  style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' onClick={() => onDelete(itemToDelete)}>
          {selectedLanguage === 'Marathi' ? 'हटवा' : ' Delete'} 
          </Button></p>
          </Modal>

</Row>
</section>
    </div>
  )
}

export default EmployeeMaster1

 
